import { Injectable } from '@angular/core';
import { settings } from '../../../settings';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class OperatingAuthorityApplicationService {
  api = settings.API_URL;
  selectedOAAdata: any = null;

  constructor(private http: HttpClient) {}

  getOperatingAuthorityApplicationService(sessionHash: string, params: any) {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    let apiUrl: any;
    if (params.permitTypeCode) {
      apiUrl =
        this.api +
        `/api/permitRequests?sessionHash=${sessionHash}&permitTypeCode=${params.permitTypeCode}`;
    } else if (params.permitId) {
      apiUrl =
        this.api +
        `/api/permitRequests?sessionHash=${sessionHash}&permitId=${params.permitId}`;
    } else {
      apiUrl = this.api + `/api/permitRequests?sessionHash=${sessionHash}`;
    }
    return this.http.get(apiUrl, {
      headers,
    });
  }

  getOperatingAuthorityApplicationFeesService(params: any) {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    return this.http.get(
      this.api +
        `/api/permitRequests/fees?sessionHash=${params.sessionHash}&permitRequestId=${params.permitRequestId}`,
      {
        headers,
      },
    );
  }

  getOperatingAuthorityApplicationInvoicesService(params: any) {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    return this.http.get(
      this.api +
        `/api/permitRequests/invoices?sessionHash=${params.sessionHash}&permitRequestId=${params.permitRequestId}`,
      {
        headers,
      },
    );
  }

  getOperatingAuthorityApplicationDocumentsService(params: any) {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    return this.http.get(
      this.api +
        `/api/permitRequests/mandatoryDocuments?sessionHash=${params.sessionHash}&permitRequestId=${params.permitRequestId}`,
      {
        headers,
      },
    );
  }

  submitPermitRequestService(params: any) {
    return this.http.put(
      this.api +
        `/api/permitRequests/submit?sessionHash=${params.sessionHash}&permitRequestId=${params.permitRequestId}`,
      params.params,
      { responseType: 'text' },
    );
  }

  applyForReinstatementService(params: any, sessionHash: string) {
    return this.http.post(
      this.api +
        `/api/permitRequests?sessionHash=${sessionHash}&permitId=${params.permitId}&permitRequestType=${params.permitRequestType}`,
      params,
      { responseType: 'text' },
    );
  }

  cancelPermitRequestService(params: any) {
    return this.http.put(
      this.api +
        `/api/permitRequests/terminate?sessionHash=${params.sessionHash}&permitRequestId=${params.permitRequestId}`,
      params.params,
      { responseType: 'text' },
    );
  }
}
